import { render, staticRenderFns } from "./Wp_test.vue?vue&type=template&id=90b4f47e&scoped=true&"
import script from "./Wp_test.vue?vue&type=script&lang=js&"
export * from "./Wp_test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b4f47e",
  null
  
)

export default component.exports